import React from "react";
import {Button,} from "@mui/material";
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

export default function DHButtonNew({ disabled, onClick}) {

    return <Button variant="contained" disabled={disabled} onClick={() => onClick()} startIcon={<InsertDriveFileIcon size={20}/>} style={{textTransform: 'none', letterSpacing:"0.1em"}}>Neu</Button>
}